export const SET_ADLIST = "SET_ADLIST";
export const SET_PLACEMENTLIST = "SET_PLACEMENTLIST";
export const SET_ADOBJECT = "SET_ADOBJECT";
export const SET_ADDETAILS = "SET_ADDETAILS";
export const SET_ENTITIES = "SET_ENTITIES";